import { useState } from "react";

import { getConfig } from "site-config";
import { fetchJSON } from "lib/fetch";

import { TAPIResponse } from "../../types";
import { API_STATES } from "../../helpers";

export type TDismissSmartOrderProducts = [];

export type TDismissSmartOrderProductsResponse = TAPIResponse<TDismissSmartOrderProducts, string> & {
    dismissSmartOrderProducts: (selectedProductsIds: string[]) => void;
};

export const useDismissSmartOrderProducts = (): TDismissSmartOrderProductsResponse => {
    const { api } = getConfig();

    const dismissSmartOrderProducts = (selectedProductsIds: string[]) => {
        APIStates.pending();

        fetchJSON<TDismissSmartOrderProducts>(`${api}/api/v3.0/smart-orders/dismiss`, {
            method: "POST",
            body: JSON.stringify(selectedProductsIds),
        })
            .then((data) => {
                APIStates.success(data);
            })
            .catch((error) => {
                APIStates.error(error);
            });
    };

    const [state, setState] = useState<TDismissSmartOrderProductsResponse>({
        ...API_STATES.default,
        dismissSmartOrderProducts,
    });

    const APIStates = API_STATES.getStates(setState);

    return {
        ...state,
        dismissSmartOrderProducts,
    };
};
